"use client";
import { j as n } from "../../../../node_modules/react/jsx-runtime.js";
import { forwardRef as k, useState as v, useRef as y, useImperativeHandle as C, useEffect as i } from "react";
import { createPortal as w } from "react-dom";
const L = k((f, m) => {
  const {
    modalRoot: u = document.body,
    initialState: b = !1,
    preventClose: t = !1,
    preventCloseOutside: h = !1,
    styles: d = "",
    children: E,
    onAfterClose: c
    // <<< NEW
  } = f, [o, s] = v(b), r = y(null);
  C(m, () => ({
    handlerModalAction: (e) => l(e)
  }));
  const l = (e) => {
    switch (e) {
      case "OPEN":
        s(!0);
        break;
      case "CLOSE":
        s(!1), c && c();
        break;
      default:
        s(!1);
    }
  }, p = (e) => {
    var a;
    e.target instanceof HTMLElement && ((a = e.target.parentElement) != null && a.classList.contains("block-overlay")) && !t && !h && l("CLOSE");
  };
  if (i(() => {
    const e = (a) => {
      a.key === "Escape" && !t && l("CLOSE");
    };
    return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
  }, [t]), i(() => {
    o && r.current && r.current.focus();
  }, [o]), o) {
    const a = `modal-${Math.random().toString(36).substring(2, 15)}`;
    return w(
      /* @__PURE__ */ n.jsx(
        "section",
        {
          ref: r,
          tabIndex: -1,
          role: "dialog",
          "aria-modal": "true",
          className: `block-overlay${d ? ` ${d}` : ""}${o ? " active" : ""}`,
          "aria-labelledby": a,
          "data-react-block": "true",
          children: /* @__PURE__ */ n.jsx("div", { className: "part", onClick: p, id: a, children: /* @__PURE__ */ n.jsxs("div", { className: "content-holder", children: [
            E,
            !t && /* @__PURE__ */ n.jsx(
              "button",
              {
                type: "button",
                "aria-label": "Fechar Janela",
                className: "close-overlay",
                onClick: () => l("CLOSE")
              }
            )
          ] }) })
        }
      ),
      u
    );
  }
  return null;
}), O = L;
export {
  O as default
};
